import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { checkoutUrl, mockupUrl } from '../data/content';
import { checkoutFeatures, pricing } from '../data/bonuses';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
export function Pricing() {
  return <section id="offer" className="scroll-mt-4 bg-brand px-4 py-12 md:py-16" aria-labelledby="offer-title" data-id="element-138" data-mp="3nqusvemj7cdj">
      <div className="mx-auto max-w-2xl" data-id="element-139" data-mp="fcukkjigot6l">
        <div className="text-center" data-id="element-140" data-mp="f9qa54eel17h">
          <p className="font-display text-[11px] font-black uppercase tracking-[.25em] text-white/90 md:text-xs" data-id="element-141" data-mp="kbfgi6qokqp8">
            Special launch offer
          </p>
          <h2 id="offer-title" className="mt-2 font-display text-xl font-black uppercase leading-tight text-white md:text-3xl" data-id="element-142" data-mp="6dh6tenb1ig2">
            Complete Injury Rehabilitation Bundle
          </h2>
          <p className="mt-2 font-display text-xs font-extrabold uppercase tracking-wide text-navy md:text-sm" data-id="element-143" data-mp="2r3gedn0ftpi5">
            The complete practical exercise system for mobility, strength & stability
          </p>
        </div>

        <article className="mt-8 rounded-3xl border-2 border-brand-light bg-white p-6 shadow-2xl md:p-8" data-id="element-144" data-mp="2aorcr2k0qmhv">
          <OfferLink href={checkoutUrl} className="mx-auto max-w-[260px]" label={`Get instant access for $${pricing.price}`} data-id="element-145" data-mp="2oose0j473vxv">
            <img src={mockupUrl} alt="Complete Injury Rehabilitation Bundle mockup" className="w-full object-contain transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-146" data-mp="2klmdzt7of0zu" />
          </OfferLink>

          <p className="mt-6 font-display text-sm font-black uppercase text-navy md:text-base" data-id="element-147" data-mp="38c043e6paprs">Complete 5-volume system</p>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-148" data-mp="33cx262m0ozo1">
            {checkoutFeatures.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-navy" data-id="element-149" data-mp="3hdzn2c1a03xd">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-150" data-mp="3cewg2m1qjnmr" />
                {item}
              </li>)}
          </ul>

          <div className="mt-6 flex items-center justify-between gap-4 rounded-xl bg-canvas px-4 py-3" data-id="element-151" data-mp="2eza87tfj2xvx">
            <span className="font-display text-xs font-black uppercase text-navy md:text-sm" data-id="element-152" data-mp="2j1dk2j6404hq">Bonus value</span>
            <span className="font-display text-lg font-black text-steel line-through decoration-red-600 decoration-[3px]" data-id="element-153" data-mp="2nsddvfjxm6g0">
              ${pricing.bonusValue} USD
            </span>
          </div>

          <div className="mt-8 text-center" data-id="element-154" data-mp="2xpi35o92qi11">
            <p className="text-[11px] font-black uppercase tracking-[.2em] text-brand md:text-xs" data-id="element-155" data-mp="2xo6sd4h7oa0f">Today</p>
            <p className="mt-2 font-display text-5xl font-black leading-none text-navy md:text-7xl" data-id="element-156" data-mp="32n052uoobwzj">
              ${pricing.price} <span className="text-xl md:text-3xl" data-id="element-157" data-mp="18b3aisuxqb09">USD</span>
            </p>
            <p className="mt-3 font-display text-xs font-black uppercase tracking-wider text-brand md:text-sm" data-id="element-158" data-mp="18d69w3hz9ghn">
              One-time payment
            </p>
            <div className="mt-6" data-id="element-159" data-mp="14u7gmfqz9ol6">
              <Button href={checkoutUrl} size="lg" fullWidth subtext="Instant Digital Access" data-id="element-160" data-mp="14ugz7i9p0tgu">
                Get instant access — ${pricing.price}
              </Button>
            </div>
            <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2 text-[10px] font-extrabold uppercase text-steel" data-id="element-161" data-mp="v3w3q3pbg525">
              <li className="flex items-center gap-1.5" data-id="element-162" data-mp="qzy3tqs62q81">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-163" data-mp="1nqqlgsur0qbx" /> 7-Day Guarantee
              </li>
              <li className="flex items-center gap-1.5" data-id="element-164" data-mp="1iqueckqr8is5">
                <LockIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-165" data-mp="1eqahlia3fh6j" /> Secure Payment
              </li>
              <li className="flex items-center gap-1.5" data-id="element-166" data-mp="19rh3bnmzfm5b">
                <CheckIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-167" data-mp="3bwzku20tvyf" /> Complete 5-Volume System
              </li>
            </ul>
          </div>
        </article>
      </div>
    </section>;
}